/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from 'react';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';
import useTranslations from '../../../../hooks/useTranslations';
import { JobMapContext } from '../JobMapContext';
import JobMapJobMedia from '../JobMapJobMedia';
import { closeIcon } from '../icons';
import {
  JobDetailActions,
  JobDetailAddress,
  JobDetailApplyButton,
  JobDetailBody,
  JobDetailBodyContent,
  JobDetailBodyHeader,
  JobDetailClear,
  JobDetailContainer,
  JobDetailDirectionsButton,
  JobDetailHeader,
  JobDetailTitle,
} from './styles';

const t = useTranslations('JobMapJobDetail');

function JobMapJobDetail() {
  const { currentJob, primaryColor, setCurrentJob } = useContext(JobMapContext);
  if (currentJob === null) return <JobDetailContainer />;

  const clearCurrentJob = () => {
    setCurrentJob(null);
  };

  const addressParts = [];
  const loc = currentJob.locations[0];
  if (loc.street_address) {
    addressParts.push(`${loc.street_address},`);
  }
  addressParts.push(loc.canonical_name);
  if (loc.postal_code) addressParts.push(loc.postal_code);
  if (
    loc.country_code !== 'US' &&
    loc.country_code.indexOf('United States') < 0
  )
    addressParts.push(loc.country_code);
  const jobLocation = addressParts.join(' ');

  useEffect(() => {
    window.TrackingParams.recordView(currentJob.tracking_params);
  }, []);

  return (
    <JobDetailContainer>
      <JobMapJobMedia jobPosting={currentJob} />
      <JobDetailHeader>
        <JobDetailTitle>{currentJob.title}</JobDetailTitle>
        <JobDetailClear size={24} onClick={clearCurrentJob}>
          {closeIcon}
        </JobDetailClear>
        {currentJob && <JobDetailAddress>{jobLocation}</JobDetailAddress>}
      </JobDetailHeader>
      <JobDetailActions>
        <JobDetailApplyButton
          text={t('job_maps.apply')}
          href={currentJob.apply_url}
          newWindow
          primaryColor={primaryColor}
        />
        <JobDetailDirectionsButton
          text={t('job_maps.directions')}
          href={`https://maps.google.com/maps?saddr=&daddr=${encodeURIComponent(
            jobLocation
          )}`}
          newWindow
          buttonType='secondary'
        />
      </JobDetailActions>
      <JobDetailBody>
        <JobDetailBodyHeader>{t('job_maps.description')}</JobDetailBodyHeader>
        <JobDetailBodyContent
          dangerouslySetInnerHTML={{ __html: currentJob.description }}
        />
        <JobDetailApplyButton
          text={t('job_maps.apply')}
          href={currentJob.apply_url}
          newWindow
          primaryColor={primaryColor}
        />
      </JobDetailBody>
    </JobDetailContainer>
  );
}

function JobMapJobDetailFallback() {
  return <JobDetailContainer />;
}

export default exportWithBoundary(JobMapJobDetail, JobMapJobDetailFallback);
